/* */ 
"use strict";
var decorators_1 = require('./util/decorators');
exports.Class = decorators_1.Class;
